module.exports = __webpack_public_path__ + "img/planet-uranus.f6890ac8.svg";